import { GET_CUTOFF_LUNCH_MENU_WATCHER, SAVE_CUTOFF_LUNCH_MENU_WATCHER, DELETE_CUTOFF_LUNCH_MENU_WATCHER, CUTOFF_LUNCH_MENU_LIST } from "../../actionTypes/admin";

export function getCutoffLunchMenuWatcher() {
    return { type: GET_CUTOFF_LUNCH_MENU_WATCHER };
}

export function saveCutoffLunchMenuWatcher(data, setOpen) {
    return { type: SAVE_CUTOFF_LUNCH_MENU_WATCHER, payload: data, setOpen };
}

export function deleteCutoffLunchMenuWatcher(id) {
    return { type: DELETE_CUTOFF_LUNCH_MENU_WATCHER, id };
}

export function cutoffLunchMenuList(data) {
    return { type: CUTOFF_LUNCH_MENU_LIST, payload: data };
}
